<div
  class="bg-white p-4 rounded-3xl shadow-2xl shadow-black/40 w-full overflow-hidden transition-transform duration-500 ease-out hover:rotate-0 rotate-[4deg]"
>
  <div
    class="relative aspect-4/3 w-full rounded-2xl overflow-hidden mb-4 bg-slate-100"
  >
    <img
      [src]="imageUrl()"
      [alt]="imageAlt()"
      class="w-full h-full object-cover opacity-90"
    />
    @if (badgeText()) {
    <div
      class="absolute top-4 right-4 bg-white/95 backdrop-blur-sm px-3 py-1.5 rounded-full shadow-sm flex items-center gap-1.5 border border-slate-100"
    >
      <span class="material-icons text-primary text-sm">cake</span>
      <span class="text-[10px] font-bold text-primary uppercase tracking-widest"
        >{{ badgeText() }}</span
      >
    </div>
    }
  </div>

  <div class="flex items-center gap-4 px-2 py-2">
    <button
      type="button"
      class="w-12 h-12 bg-primary hover:bg-primary-dark rounded-full flex items-center justify-center text-white shadow-md shadow-primary/30 shrink-0 transition-colors"
      aria-label="Reproducir"
      (click)="onPlay()"
    >
      <span class="material-icons text-2xl ml-0.5">play_arrow</span>
    </button>
    <div class="grow min-w-0">
      <div class="flex justify-between items-end mb-1.5 px-1">
        <span class="text-xs font-semibold text-slate-800"
          >{{ audioTitle() }}</span
        >
        <span class="text-[10px] text-slate-400 font-mono"
          >{{ audioDuration() }}</span
        >
      </div>
      <div
        class="memory-preview-waveform h-8 flex items-end gap-0.5 opacity-80"
        role="img"
        [attr.aria-label]="'Onda de audio ' + audioTitle()"
      >
        @for (bar of waveformBars(); track $index) {
        <span
          class="memory-preview-waveform-bar w-1 rounded-full bg-primary"
          [style.height.rem]="bar.h"
          [style.opacity]="bar.opacity"
          [style.animation-delay.ms]="$index * 80"
        ></span>
        }
      </div>
    </div>
  </div>
</div>
